<div
  #cm
  [id]="'cm-' + id"
  [hidden]="!show"
  class="bfx-context-menu"
  (contextmenu)="hideMenu()"
  [style.left.px]="position.x"
  [style.top.px]="position.y"
  [@showHideMenu]="show ? 'show' : 'hide'"
  (@showHideMenu.start)="showHideMenuStarted($event,cm)"
>
  <ul class="">
    <ng-template let-menuItem ngFor [ngForOf]="menuItems">
      <li
        *ngIf="!isItemSeparator(menuItem)"
        [ngClass]="{ 
          'bfx-context-menu-item-enabled': isItemEnabled(menuItem), 
          'bfx-context-menu-item-disabled': !isItemEnabled(menuItem) 
        }"
        (click)="selectedMenuItem(menuItem, $event)"
      >
        <i
          *ngIf="menuItem.state.iconClass && !isItemSeparator(menuItem) && !menuItem.state.iconPositionRight"
          class="{{menuItem.state.iconClass}} bfx-context-menu-icon"
          aria-hidden="true"
        ></i>
        <span *ngIf="!isItemSeparator(menuItem)">{{menuItem.title}}</span>
        <i
          *ngIf="menuItem.state.iconClassRight && !isItemSeparator(menuItem)"
          class="{{menuItem.state.iconClassRight}} bfx-context-menu-arrow"
          aria-hidden="true"
        ></i>
      </li>
      <hr class="bfx-context-menu-hr" *ngIf="isItemSeparator(menuItem)" />
    </ng-template>
  </ul>
</div>
